<template>
  <div :id="echartId" class="echartsPieOne"></div>
</template>
<script>
import { v4 } from "uuid";
import * as echarts from "echarts";
export default {
  name: "EchartsPieOne",
  props: {
    // 环形类型
    pieOneType: {
      type: String,
      default: "1",
    },
    pieData: {
      default: () => ({}),
    },
  },
  data() {
    return {
      option: {
        title: {
          text: "4.5分",
          left: "center",
          top: "34.8%",
          textStyle: {
            fontSize: "12",
            color: "#FFFFFF",
            fontWeight: 500,
          },
        },
        series: [
          {
            type: "pie",
            top: "-18.22%",
            hoverAnimation: false,
            label: {
              show: false,
            },
            data: [
              {
                value: 4,
                itemStyle: {
                  //normal: {
                  //颜色渐变
                  color: {
                    type: "radial",
                    x: 0.5,
                    y: 0.5,
                    r: 0.5,
                    colorStops: [
                      { offset: 0, color: "#B5FFD6" },
                      { offset: 1, color: "#40EE8E" },
                    ],
                    globalCoord: false,
                  },
                  fontSize: "12px",
                  //},
                },
              },
              {
                value: 5 - 4,
                itemStyle: {
                  //normal: {
                  //颜色渐变
                  color: "#283051",
                  //},
                },
              },
            ],
            radius: ["65.02%", "100%"],
          },
        ],
      },
      echartId: "echart" + v4(),
      myChart: null, //全局的echars对象
    };
  },
  watch: {
    pieData() {
      this.initEchart();
    },
  },
  methods: {
    setOption() {
      if (this.pieOneType == "1") {
        this.option.title.text = this.pieData.score == '暂无数据' ? '暂无数据' : this.pieData.score + "分";
        this.option.series[0].data[0].value = this.pieData.score;
        this.option.series[0].data[1].value = 10 - this.pieData.score;
        this.option.series[0].data[0].itemStyle.color.colorStops =
          this.pieData.colorStops;
      } else if (this.pieOneType == "2") {
        let proportion = this.pieData.proportion;
        this.option.title.text = proportion;
        this.option.series[0].data[0].value = proportion.substring(
          0,
          proportion.length - 1
        );
        this.option.series[0].data[1].value =
          100 - proportion.substring(0, proportion.length - 1);
        this.option.series[0].data[0].itemStyle.color.colorStops =
          this.pieData.colorStops;
      }
    },
    initEchart() {
      this.setOption();
      this.$nextTick(() => {
        //判断图表是否已经存在再次重新渲染
        if (this.myChart != null && this.myChart != "" && this.myChart != undefined) {
          this.myChart.dispose();//销毁
        }
        this.myChart = echarts.init(
          document.getElementById(this.echartId),
          null,
          { renderer: "svg" }
        );
        this.myChart.setOption(this.option);
        window.addEventListener("resize", () => {
          this.myChart.resize();
        });
      });
    },
  },
  mounted() {
    this.echartId = "echart" + v4();
    this.initEchart();
  },
};
</script>
<style lang="less" scoped>
.echartsPieOne {
  width: 100%;
  height: 100%;
  position: relative;
  top: 5%;
}
</style>